import type { ExchangeRate } from 'src/apis/remit-reporting/types';
import { useAxios } from 'src/hooks/use-axios';

export function useExchangeRate() {
  const exchangeRate = useAxios(
    (axios, baseConfig, currency: string) =>
      axios.request<ExchangeRate>({
        ...baseConfig,
        url: `${PRISMA_CONFIG.remitReporting}/api/platform/exchange-rate`,
        params: { currency },
        method: 'GET',
      }),
    {
      neededOnPageLoad: false,
    }
  );

  return exchangeRate;
}

export type ExchangeRateRequest = ReturnType<typeof useExchangeRate>;
